export function SkipLink() {
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-gold focus:text-navy focus:px-4 focus:py-2 focus:rounded focus:font-semibold focus:outline-none focus:ring-2 focus:ring-gold-bright"
    >
      Hoppa till huvudinnehåll
    </a>
  );
}
